/* Boulevard theme — vanilla JS, no dependencies. */
(function () {
  'use strict';

  var money = function (cents) {
    var f = (window.BLVD && window.BLVD.moneyFormat) || '${{amount}}';
    var amt = (cents / 100).toFixed(2);
    var parts = amt.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts.join(','))
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
  };

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------------- Focus trap */
  function trap(container, onEscape) {
    var sel = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
    function key(e) {
      if (e.key === 'Escape') { onEscape(); return; }
      if (e.key !== 'Tab') return;
      var f = $$(sel, container).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', key);
    return function () { container.removeEventListener('keydown', key); };
  }

  /* ---------------------------------------------------------------- Overlays */
  var openStack = [];
  function openOverlay(el) {
    if (!el || el.classList.contains('is-open')) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    el._lastFocus = document.activeElement;
    el._untrap = trap(el, function () { closeOverlay(el); });
    openStack.push(el);
    var f = el.querySelector('[data-autofocus]') || el.querySelector('button, a[href], input');
    if (f) setTimeout(function () { f.focus(); }, 90);
  }
  function closeOverlay(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (el._untrap) el._untrap();
    openStack = openStack.filter(function (x) { return x !== el; });
    if (!openStack.length) document.body.classList.remove('is-locked');
    if (el._lastFocus && el._lastFocus.focus) el._lastFocus.focus();
  }
  window.BLVDOpen = openOverlay;
  window.BLVDClose = closeOverlay;

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openOverlay($('#' + o.getAttribute('data-open'))); return; }
    var c = e.target.closest('[data-close]');
    if (c) { e.preventDefault(); closeOverlay(c.closest('.drawer, .search-panel')); return; }
    if (e.target.classList && e.target.classList.contains('drawer__scrim')) {
      closeOverlay(e.target.closest('.drawer'));
    }
    if (e.target.classList && e.target.classList.contains('search-panel__scrim')) {
      closeOverlay(e.target.closest('.search-panel'));
    }
  });

  /* ---------------------------------------------------------------- Header height var */
  function headerVar() {
    var h = $('.header');
    if (h) document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px');
  }
  window.addEventListener('resize', headerVar);
  headerVar();

  var lastY = 0;
  window.addEventListener('scroll', function () {
    var h = $('.header');
    if (h) h.classList.toggle('is-stuck', window.scrollY > 8);
    lastY = window.scrollY;
  }, { passive: true });

  /* ---------------------------------------------------------------- Mobile nav */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.mnav__toggle');
    if (!t) return;
    var open = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', String(!open));
    var sub = document.getElementById(t.getAttribute('aria-controls'));
    if (sub) sub.classList.toggle('is-open', !open);
  });

  /* ---------------------------------------------------------------- Accordions */
  function initAcc(root) {
    $$('.acc__btn', root || document).forEach(function (btn) {
      if (btn._init) return;
      btn._init = true;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      if (btn.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (open) {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () { panel.style.height = '0px'; });
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          panel.addEventListener('transitionend', function te() {
            panel.style.height = 'auto';
            panel.removeEventListener('transitionend', te);
          });
        }
      });
    });
  }
  initAcc();

  /* ---------------------------------------------------------------- Tabs */
  $$('[data-tabs]').forEach(function (group) {
    var tabs = $$('[role="tab"]', group);
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var next = tabs[(i + d + tabs.length) % tabs.length];
        next.focus(); select(next);
      });
    });
  });

  /* ---------------------------------------------------------------- Rails */
  $$('[data-rail]').forEach(function (wrap) {
    var rail = $('.rail', wrap);
    if (!rail) return;
    $$('[data-rail-dir]', wrap).forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = b.getAttribute('data-rail-dir') === 'next' ? 1 : -1;
        var first = rail.firstElementChild;
        var step = first ? first.getBoundingClientRect().width + 16 : 300;
        rail.scrollBy({ left: dir * step * (window.innerWidth > 900 ? 2 : 1), behavior: 'smooth' });
      });
    });
  });

  /* ---------------------------------------------------------------- Announcement rotator */
  (function () {
    var box = $('[data-announce]');
    if (!box) return;
    var slides = $$('.announce__slide', box);
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-on');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-on');
    }, 5000);
  })();

  /* ---------------------------------------------------------------- Reveal on scroll */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    $$('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ================================================================ CART */
  var Cart = {
    drawer: function () { return $('#CartDrawer'); },

    setCount: function (n) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.hidden = n === 0;
        el.classList.remove('is-bump');
        void el.offsetWidth;            // restart the animation
        el.classList.add('is-bump');
      });
    },

    count: function () {
      var el = $('[data-cart-count]');
      return el ? (parseInt(el.textContent, 10) || 0) : 0;
    },

    async refresh(open) {
      try {
        // both requests in parallel — was sequential, which doubled the wait
        var results = await Promise.all([
          fetch(window.Shopify.routes.root + '?section_id=cart-drawer').then(function (r) { return r.text(); }),
          fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); })
        ]);
        var doc = new DOMParser().parseFromString(results[0], 'text/html');
        var cart = results[1];

        ['[data-cart-content]', '[data-cart-foot]'].forEach(function (sel) {
          var fresh = doc.querySelector(sel);
          var target = $(sel);
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        });

        this.setCount(cart.item_count);   // authoritative
        this.shipbar(cart);
        initAcc();
      } catch (err) { console.error('[cart]', err); }
      if (open) openOverlay(this.drawer());
    },

    shipbar: function (cart) {
      var bar = $('[data-shipbar]');
      if (!bar) return;
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
      if (!threshold) { bar.hidden = true; return; }
      bar.hidden = false;
      var total = cart.total_price;
      var pct = Math.min(100, (total / threshold) * 100);
      var fill = $('.shipbar__fill', bar);
      var text = $('.shipbar__text', bar);
      if (fill) fill.style.width = pct + '%';
      bar.classList.toggle('is-done', total >= threshold);
      if (text) {
        text.innerHTML = total >= threshold
          ? (bar.getAttribute('data-done') || 'Free shipping unlocked')
          : (bar.getAttribute('data-away') || 'You are {{amount}} from free shipping')
              .replace('{{amount}}', '<b>' + money(threshold - total) + '</b>');
      }
    },

    async add(formData, btn) {
      var label = btn ? btn.innerHTML : null;
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.innerHTML = 'Adding…'; }
      // optimistic: the badge moves the instant they click, before the round trip
      var bumped = parseInt(formData.get('quantity'), 10) || 1;
      this.setCount(this.count() + bumped);
      try {
        var res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST', body: formData
        });
        var data = await res.json();
        if (data.status) throw new Error(data.description || data.message);
        await this.refresh(true);
        if (btn) { btn.innerHTML = 'Added'; setTimeout(function () { btn.innerHTML = label; btn.removeAttribute('aria-disabled'); }, 1400); }
      } catch (err) {
        this.setCount(Math.max(0, this.count() - bumped));   // roll the optimistic bump back
        if (btn) { btn.innerHTML = label; btn.removeAttribute('aria-disabled'); }
        var msg = $('[data-form-error]', btn ? btn.closest('form') : document);
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
        else alert(err.message);
      }
    },

    async change(key, qty) {
      try {
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        await this.refresh(false);
      } catch (err) { console.error('[cart]', err); }
    }
  };
  window.BLVDCart = Cart;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-cart-add]')) return;
    e.preventDefault();
    var err = $('[data-form-error]', form);
    if (err) err.hidden = true;
    Cart.add(new FormData(form), form.querySelector('[data-add-btn]'));
  });

  document.addEventListener('click', function (e) {
    var line = e.target.closest('[data-line-key]');
    var qb = e.target.closest('[data-qty]');
    if (qb && line) {
      var input = $('input', qb.parentElement);
      var v = parseInt(input.value, 10) || 1;
      v = qb.getAttribute('data-qty') === 'up' ? v + 1 : Math.max(0, v - 1);
      input.value = v;
      Cart.change(line.getAttribute('data-line-key'), v);
      return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm && line) { e.preventDefault(); Cart.change(line.getAttribute('data-line-key'), 0); }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    var line = input.closest('[data-line-key]');
    if (line) Cart.change(line.getAttribute('data-line-key'), parseInt(input.value, 10) || 0);
  });

  /* Standalone quantity steppers (product page) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qstep]');
    if (!b) return;
    var input = $('input', b.parentElement);
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, b.getAttribute('data-qstep') === 'up' ? v + 1 : v - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ================================================================ Predictive search */
  (function () {
    var panel = $('#SearchPanel');
    if (!panel) return;
    var input = $('input[name="q"]', panel);
    var results = $('[data-psearch]', panel);
    var seed = results ? results.innerHTML : '';
    if (!input || !results) return;
    var t, ctrl;

    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = seed; return; }
      t = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        var url = window.Shopify.routes.root + 'search/suggest?q=' + encodeURIComponent(q) +
                  '&resources[type]=product,collection,query&resources[limit]=6&section_id=predictive-search';
        fetch(url, { signal: ctrl.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-psearch]');
            results.innerHTML = fresh ? fresh.innerHTML : '';
          })
          .catch(function () {});
      }, 220);
    });
  })();

  /* ================================================================ Product page */
  function initProduct(root) {
    var form = $('[data-product-form]', root);
    if (!form) return;
    var data = $('[data-variants]', root);
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    var idInput = $('[data-variant-id]', form);
    var priceBox = $('[data-price-box]', root);
    var addBtn = $('[data-add-btn]', form);
    var stock = $('[data-stock]', root);
    var sticky = $('[data-sticky-price]');

    function selected() {
      return $$('[data-opt]', root)
        .filter(function (el) { return el.checked || el.tagName === 'SELECT'; })
        .map(function (el) { return el.value; });
    }

    function match(opts) {
      /* No option inputs on the page at all. That happens for single-variant
         products (the Variants block is wrapped in `unless has_only_default_variant`)
         and if the Variants block isn't in the product template.
         Previously this compared ["Default Title"] against [] and matched nothing,
         which pushed every such product into the Unavailable state. */
      if (!opts.length) {
        return variants.find(function (v) { return v.available; }) || variants[0];
      }
      /* Iterate the SELECTED options, not the variant's. If a product has three
         options but only two pickers are rendered, we still resolve a variant. */
      return variants.find(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      });
    }

    function render(v) {
      if (!v) {
        /* Only reachable now if the shopper picked a genuinely nonexistent combo. */
        if (addBtn) {
          addBtn.setAttribute('aria-disabled', 'true');
          addBtn.textContent = 'Unavailable in this combination';
        }
        return;
      }
      if (idInput) idInput.value = v.id;

      if (priceBox && v.html) priceBox.innerHTML = v.html;

      if (addBtn) {
        if (v.available) {
          addBtn.removeAttribute('aria-disabled');
          addBtn.textContent = addBtn.getAttribute('data-label') || 'Add to bag';
        } else {
          addBtn.setAttribute('aria-disabled', 'true');
          addBtn.textContent = 'Sold out';
        }
      }

      if (stock) {
        stock.className = 'stock-line';
        if (!v.available) { stock.classList.add('is-out'); stock.querySelector('span:last-child').textContent = 'Out of stock'; }
        else if (v.qty !== null && v.qty > 0 && v.qty <= 5) {
          stock.classList.add('is-low');
          stock.querySelector('span:last-child').textContent = 'Only ' + v.qty + ' left at this price';
        } else {
          stock.querySelector('span:last-child').textContent = 'In stock — ships in 1–2 business days';
        }
      }

      if (sticky && v.priceText) sticky.innerHTML = v.priceText;

      // Swap gallery to the variant image if it has one
      if (v.image) {
        var main = $('.gallery__main img', root);
        if (main && main.src !== v.image) main.src = v.image;
        $$('.gallery__thumb', root).forEach(function (th) {
          th.setAttribute('aria-current', String(th.getAttribute('data-src') === v.image));
        });
      }

      // Keep the URL shareable
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      }
    }

    $$('[data-opt]', root).forEach(function (el) {
      el.addEventListener('change', function () { render(match(selected())); });
    });

    render(match(selected()));

    /* Sticky buy bar */
    var bar = $('[data-stickybuy]');
    var anchor = $('[data-buybox]', root);
    if (bar && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-on', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(anchor);
      var proxy = $('[data-sticky-add]', bar);
      if (proxy) proxy.addEventListener('click', function () {
        Cart.add(new FormData(form), proxy);
      });
    }

    /* Gallery */
    $$('.gallery__thumb', root).forEach(function (th) {
      th.addEventListener('click', function () {
        var main = $('.gallery__main img', root);
        if (main) main.src = th.getAttribute('data-src');
        $$('.gallery__thumb', root).forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        th.setAttribute('aria-current', 'true');
      });
    });
  }
  $$('[data-product-root]').forEach(initProduct);

  /* ---------------------------------------------------------------- Product recommendations */
  $$('[data-recommendations]').forEach(function (sec) {
    var url = sec.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations] .rail');
        var target = $('.rail', sec);
        if (fresh && target && fresh.children.length) target.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* Liquid fallback already rendered */ });
  });

  /* ---------------------------------------------------------------- Section re-init (theme editor) */
  document.addEventListener('shopify:section:load', function (e) {
    initAcc(e.target);
    $$('[data-product-root]', e.target).forEach(initProduct);
    headerVar();
  });

  /* ---------------------------------------------------------------- Newsletter inline feedback */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-newsletter]');
    if (!f) return;
    var btn = f.querySelector('button[type="submit"]');
    if (btn) btn.textContent = 'Joining…';
  });

  /* Prime the cart bits on load */
  if ($('[data-shipbar]')) {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { Cart.shipbar(c); })
      .catch(function () {});
  }
})();
